import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';

import { ItemCardSellerRow } from '@/components/ItemCardSellerRow/ItemCardSellerRow';
import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryLotLocationDisplay } from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';

export type SellerNameComponentSearchCardProps = ItemSummary & { position: number };

export const SellerNameComponentSearchCard = createInfo<SellerNameComponentSearchCardProps>({
    className: 'line-clamp-0',
    useText: ({ itemId }) => {
        const isMobile = useIsMobileLayout();
        const {
            city: lotLocationCity,
            countryCode: lotLocationCountryCode,
            region: lotLocationRegion,
        } = useAppSelector((state) => getItemSummaryLotLocationDisplay(state, itemId));

        const sellerLocation =
            lotLocationCity === lotLocationRegion
                ? [lotLocationCity, lotLocationCountryCode].filter(Boolean).join(', ')
                : [lotLocationCity, lotLocationRegion].filter(Boolean).join(', ');

        return (
            <ItemCardSellerRow
                className="px-xs pb-xs smMin:px-sm smMin:pb-sm"
                itemId={itemId}
                location={sellerLocation}
                shouldHideRatingTrailingText={isMobile}
            />
        );
    },
});
